import React, { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import startCase from "lodash/startCase";
import usePluginEntities from "hooks/usePluginEntities";
import TitleCell from "views/components/dashboard/DashboardsOverview/TitleCell";
import FavoriteIcon from "views/components/FavoriteIcon";
import { createGRN } from "logic/permissions/GRN";
import { useTableFetchContext } from "components/common/PaginatedEntityTable";
const DashboardFavoriteItem = ({ favorite, dashboardId }) => {
  const queryClient = useQueryClient();
  const { searchParams } = useTableFetchContext();
  return /* @__PURE__ */ React.createElement(
    FavoriteIcon,
    {
      isFavorite: favorite,
      grn: createGRN("dashboard", dashboardId),
      onChange: (newValue) => {
        queryClient.setQueriesData(
          { queryKey: ["dashboards", "overview", searchParams] },
          (cur) => ({
            ...cur,
            list: cur.list.map((view) => {
              if (view.id === dashboardId) {
                return view.toBuilder().favorite(newValue).build();
              }
              return view;
            })
          })
        );
      }
    }
  );
};
export const useColumnRenderers = (pluggableColumnRenderers) => {
  const requirementsProvided = usePluginEntities("views.requires.provided");
  const customColumnRenderers = useMemo(
    () => ({
      attributes: {
        title: {
          renderCell: (_title, dashboard) => /* @__PURE__ */ React.createElement(TitleCell, { dashboard, requirementsProvided })
        },
        "_entity_source.source": {
          renderCell: (_title, dashboard) => /* @__PURE__ */ React.createElement("span", null, dashboard._value.entitySource ? startCase(dashboard._value.entitySource.source.toString().toLowerCase()) : "User Defined")
        },
        favorite: {
          renderCell: (favorite, dashboard) => /* @__PURE__ */ React.createElement(DashboardFavoriteItem, { dashboardId: dashboard.id, favorite })
        },
        ...pluggableColumnRenderers || {}
      }
    }),
    [requirementsProvided, pluggableColumnRenderers]
  );
  return customColumnRenderers;
};
export default useColumnRenderers;
